import { DateInput } from '../DateInput'

import * as styles from './DateRangeInput.module.css'

function DateRangeInput({
  Input = DateInput,
  containerRef,
  endPlaceholder,
  endValue,
  isRange,
  maxValue,
  minValue,
  singleValue,
  startPlaceholder,
  startValue,
  onChangeRange,
  onChangeSingle,
  ...restProps
}) {
  if (!isRange) {
    return (
      <Input
        {...restProps}
        containerRef={containerRef}
        maxValue={maxValue}
        minValue={minValue}
        placeholder={startPlaceholder}
        value={singleValue}
        wrapperClassName={styles.inputWrap}
        onChange={onChangeSingle}
      />
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.datePickerInputControl} ref={containerRef}>
        <Input
          {...restProps}
          className={styles.rangeStart}
          maxValue={endValue ?? maxValue}
          minValue={minValue}
          placeholder={startPlaceholder}
          value={startValue}
          onChange={next => onChangeRange?.([next, endValue])}
        />
        <Input
          {...restProps}
          className={styles.rangeEnd}
          maxValue={maxValue}
          minValue={startValue ?? minValue}
          placeholder={endPlaceholder}
          value={endValue}
          onChange={next => onChangeRange?.([startValue, next])}
        />
      </div>
    </div>
  )
}

export default DateRangeInput
